/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TenantBranchApi } from '../api/tenantbranch.api';
import { switchMap, map } from 'rxjs/operators';
import { TenantBranchData, TenantBranch, onBoardNewCustomer } from '../../../interfaces/masters/tenantbranch';
//import { Tenant } from '../../../interfaces/masters/tenant';

@Injectable()
export class TenantBranchService extends TenantBranchData {

  constructor(private api: TenantBranchApi) {
    super();
  }



  list(url: string): Observable<TenantBranch[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<TenantBranch>{
      return this.api.getById(url);
  }

  create(url: string, data:TenantBranch): Observable<TenantBranch> {
    return this.api.add(url,data);
  }
  onBoardNewCustomer(url: string, data:onBoardNewCustomer): Observable<onBoardNewCustomer> {
    return this.api.onBoardNewCustomer(url,data);
  }
  update(url: string, data:TenantBranch): Observable<TenantBranch> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
